import { render, staticRenderFns } from "./MiddleTable.vue?vue&type=template&id=563af5f6&scoped=true&"
import script from "./MiddleTable.vue?vue&type=script&lang=js&"
export * from "./MiddleTable.vue?vue&type=script&lang=js&"
import style0 from "./MiddleTable.vue?vue&type=style&index=0&id=563af5f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563af5f6",
  null
  
)

export default component.exports